// @flow

import _ from 'lodash';

import type {
  VariantsDisplayState,
  VariantsDisplayAction
} from 'stores/flow-type/variants-display.type';

import {
  GET_VARIANTS_DISPLAY_REQUEST,
  GET_VARIANTS_DISPLAY_SUCCESS,
  GET_VARIANTS_DISPLAY_FAILURE,
  UPDATE_VARIANTS_DISPLAY_REQUEST,
  UPDATE_VARIANTS_DISPLAY_SUCCESS,
  UPDATE_VARIANTS_DISPLAY_FAILURE,
  CHECK_MER_PRODUCT_ID_SUCCESS
} from 'stores/flow-type/variants-display.type';

const initialState: VariantsDisplayState = {
  getLoading: false,
  updateLoading: false,
  updateSuccess: false,
  error: undefined,
  variantsDisplay: {},
  scheduleSyncIn: 0,
  scheduleSyncAfter: 0,
  waitSyncAt: 0,
  isExistsMERProductId: false
};

const variantsDisplayReducers = (
  state: VariantsDisplayState = initialState,
  action: VariantsDisplayAction
) => {
  switch (action.type) {
    case GET_VARIANTS_DISPLAY_REQUEST:
      return { ...state, getLoading: true, waitSyncAt: 0, scheduleSyncIn: 0, scheduleSyncAfter: 0 };

    case GET_VARIANTS_DISPLAY_SUCCESS: {
      const { data } = action.payload;
      const variantsDisplay = _.get(data, 'data.settings', {});
      return {
        ...state,
        getLoading: false,
        error: undefined,
        variantsDisplay
      };
    }
    case GET_VARIANTS_DISPLAY_FAILURE:
      return {
        ...state,
        getLoading: false,
        error: action.payload,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case UPDATE_VARIANTS_DISPLAY_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateSuccess: false,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case UPDATE_VARIANTS_DISPLAY_SUCCESS: {
      const { data = {} } = action.payload;
      const { data: variantsDisplay, waitSyncAt, scheduleSyncIn, scheduleSyncAfter } = data;

      return {
        ...state,
        updateLoading: false,
        error: undefined,
        updateSuccess: true,
        variantsDisplay,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      };
    }

    case UPDATE_VARIANTS_DISPLAY_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: false,
        error: action.payload,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };

    case CHECK_MER_PRODUCT_ID_SUCCESS: {
      const { isExist } = action.payload.data;
      return {
        ...state,
        isExistsMERProductId: isExist
      };
    }
    default:
      return state;
  }
};

export default variantsDisplayReducers;
